/* eslint-disable camelcase */
import { Button, Form, Input, Select, Space } from 'antd';
import { useRef } from 'react';
import { Images } from '../../../assets/images/Index';
import { ProductFilter } from '../../../interfaces';
import '../../../sass/components/_filters.scss';
import { ImportFilterProps } from './Import.types';

export const Filters = ({
  actionData,
  searchValue,
  languages,
  setSearchValue,
  importData,
  handleOnChange,
  loadingImport,
  form,
  action,
}: ImportFilterProps) => {
  const inputEl = useRef<any>();
  const handeLanguage = (language: string) => handleSetFilter({ language });
  const handleSetFilter = (value: ProductFilter) => {
    setSearchValue({ ...searchValue, ...value });
  };

  return (
    <>
      {actionData != 'action' && (
        <div className="product-filter import-design">
          <div>
            <Space direction="horizontal" className="filters">
              <Form form={form} layout="inline">
                {action != 'products_price' && (
                  <>
                    <Form.Item name="translated" label="Language:" className="select-width">
                      <Select
                        dropdownMatchSelectWidth={false}
                        suffixIcon={<img src={Images.arrowCDown} />}
                        className="language_fliter"
                        placeholder="All"
                        onChange={handeLanguage}
                        bordered={false}
                        defaultValue="English"
                      >
                        {languages.map(item => (
                          <Select.Option value={item.iso_code} key={item.iso_code}>
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                )}

                <Form.Item name="file" label="Select File:" className="select-width">
                  <Input
                    className="import-design-form-input"
                    type="file"
                    accept=".xlsx"
                    onChange={handleOnChange}
                    ref={inputEl}
                  />
                </Form.Item>
              </Form>
            </Space>
          </div>
          <div>
            <Button onClick={importData} loading={loadingImport} disabled={loadingImport}>
              Import
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
